import { AuthFeature, AuthPage, RoleType } from './auth.enums'

export const RoleTypeKey = {
  [RoleType.Admin]: 'MTR_ROLE_ADMIN',
  [RoleType.Support]: 'MTR_ROLE_SUPPORT',
  [RoleType.Production]: 'MTR_ROLE_PRODUCTION',
  [RoleType.Technician]: 'MTR_ROLE_TECHNICIAN',
  [RoleType.Sales]: 'MTR_ROLE_SALES',
  [RoleType.DataOperator]: 'MTR_ROLE_DATA_OPERATOR',
}

export const ROLE_MAPPING = {
  [RoleType.Admin]: {
    permissions: [
      AuthPage.Administration,
      AuthPage.UserCustomerView,
      AuthPage.Marketable,
      AuthPage.PermissionManagement,
      AuthPage.DataIncoming,
      AuthPage.DataPublishing,
      AuthPage.Stadium,
      AuthPage.Stadiums,
      AuthPage.License,
      AuthPage.MediaReports,
      AuthPage.Playground,
      AuthPage.PlayersManager,
    ],
    features: [AuthFeature.ReportIssue, AuthFeature.SetMatchQualifier],
  },
  [RoleType.Support]: {
    permissions: [
      AuthPage.UserCustomerView,
      AuthPage.DataIncoming,
      AuthPage.DataPublishing,
      AuthPage.License,
      AuthPage.MediaReports,
      AuthPage.Playground,
    ],
    features: [AuthFeature.ReportIssue],
  },
  [RoleType.Production]: {
    permissions: [
      AuthPage.DataIncoming,
      AuthPage.DataPublishing,
      AuthPage.Stadium,
      AuthPage.Stadiums,
      AuthPage.Playground,
    ],
    features: [AuthFeature.ReportIssue, AuthFeature.SetMatchQualifier],
  },
  [RoleType.Technician]: {
    permissions: [
      AuthPage.DataIncoming,
      AuthPage.DataPublishing,
      AuthPage.MediaReports,
      AuthPage.Playground,
      AuthPage.PlayersManager,
    ],
    features: [],
  },
  [RoleType.Sales]: {
    permissions: [AuthPage.UserCustomerView, AuthPage.Playground, AuthPage.Marketable],
    features: [],
  },
}
